import {Component, OnInit} from "@angular/core";
import {AnnouncementService} from "../../../../../shared/services/announcement.service";
import {Router} from "@angular/router";
import {Announcement} from "../../interfaces/announcement";
import {Subscription} from "rxjs";
import moment from "moment";
import {PaginationObject} from "../../../pagination-object";

@Component({
    selector: 'view_announcements',
    templateUrl: './view_announcements.component.html',
    styleUrls: ['./view_announcements.component.scss'],
    providers: [AnnouncementService]
})

export class ViewAnnouncements implements OnInit {

    constructor(
        private readonly router: Router,
        private readonly service: AnnouncementService
    ) {
    }

    private announcementTableSubscription: Subscription;
    private paginationSubscription: Subscription;

    private readonly STATUS_ACTIVE: string = 'ACTIVE';
    private readonly STATUS_FUTURE: string = 'FUTURE';
    private readonly STATUS_EXPIRED: string = 'EXPIRED';
    private readonly MAX_CHARS: number = 40;

    activeRecordList: Announcement[] = new Array<Announcement>();
    pagination: PaginationObject = new PaginationObject();

    ngOnInit(): void {
        this.announcementTableSubscription = this.service.currentAnnouncementTable
            .subscribe(message => this.activeRecordList = message);
        this.paginationSubscription = this.service.currentAnnouncementPagination
            .subscribe(message => this.pagination = message);
        this.service.getAnnouncementsPaginated().subscribe(resp => {
            this.service.changeMessage(this.service.toRecordObjectList(resp));
        }, error => {}, () => {
            this.service.getAnnouncementCount().subscribe(resp => {
                this.service.updatePagination(resp)
            });
        });
    }

    statusForDates(start, end) {
        const effectiveDate = moment(start);
        const endDate = moment(end);
        const now = moment();
        if (now.isSameOrAfter(effectiveDate) && now.isSameOrBefore(endDate)) {
            return this.STATUS_ACTIVE;
        }
        if (now.isBefore(effectiveDate) && effectiveDate.isSameOrBefore(endDate)) {
            return this.STATUS_FUTURE;
        }
        if (now.isAfter(endDate) && now.isSameOrAfter(effectiveDate)) {
            return this.STATUS_EXPIRED;
        }

        return this.STATUS_EXPIRED;
    }

    statusForDatesForView(start, end) {
        const status = this.statusForDates(start, end);

        if (status === this.STATUS_ACTIVE) {
            return 'status-active';
        }
        if (status === this.STATUS_FUTURE) {
            return 'status-future';
        }

        return 'status-expired';
    }
}
